import { autoUpdate, computePosition, flip, offset, shift } from "@floating-ui/dom";
import { Controller } from "@hotwired/stimulus";
import { toggle as elToggle, leave } from "el-transition";

export default class extends Controller {
  static targets = ["menu"];

  static values = {
    offset: { type: Number, default: 0 },
    padding: { type: Number, default: 0 },
    placement: { type: String, default: "bottom" },
  };

  #cleanup;

  toggle(event) {
    this.#cleanup = autoUpdate(this.element, this.menuTarget, this.#updatePosition);
    elToggle(this.menuTarget);
  }

  hide(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains("hidden")) {
      leave(this.menuTarget);
      this.#cleanup();
    }
  }

  get #positionOptions() {
    return {
      strategy: "fixed",
      placement: this.placementValue,
      middleware: [
        // Offset the menu to avoid touching the input.
        offset(this.offsetValue),
        // Changes the placement of the menu to keep it in view.
        flip(),
        // Shifts the menu to keep it in view.
        shift({ crossAxis: false, mainAxis: false, padding: this.paddingValue }),
      ],
    };
  }

  #updatePosition = () => {
    computePosition(this.element, this.menuTarget, this.#positionOptions).then(({ x, y }) => {
      Object.assign(this.menuTarget.style, { left: `${x}px`, top: `${y}px` });
    });
  };
}
